import { render, staticRenderFns } from "./FormManufacturer.vue?vue&type=template&id=48125080"
import script from "./FormManufacturer.vue?vue&type=script&lang=js"
export * from "./FormManufacturer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports